var map = {
	"./1-en.wav": "Lsx4",
	"./2-en.wav": "pfV3",
	"./3-en.wav": "r+8J",
	"./4-en.wav": "AmSE",
	"./5-en.wav": "hjXr",
	"./6-en.wav": "d0S8",
	"./7-en.wav": "7BT+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5lP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio ^\.\/.*\-en\.wav$
// module id = a5lP
// module chunks = 1